/**
 * Roles that ALWAYS have access to a given module, regardless of
 * `module_visibility` DB rows or hard-coded fallback lists.
 *
 * Used by:
 *   - useModuleVisibility (sidebar rendering)
 *   - useModuleAccessPreflight (route gates)
 *   - ModuleVisibilityMatrix (UI shows a locked "Always on" chip)
 */
export const ALWAYS_ON_BY_MODULE: Record<string, string[]> = {
  attendance: [
    "security_man",
    "cr_cmt4", "cr_cmt5", "cr_cmt6",
    "cr_pst4", "cr_pst5", "cr_pst6",
    "cr_sw4", "cr_sw5", "cr_sw6",
  ],
};

/** Returns true if the given role is hard-wired on for the module. */
export function isAlwaysOn(moduleKey: string, role: string): boolean {
  return ALWAYS_ON_BY_MODULE[moduleKey]?.includes(role) ?? false;
}

/** Returns true if any of the user's roles is hard-wired on for the module. */
export function anyRoleAlwaysOn(moduleKey: string, roles: string[]): boolean {
  const list = ALWAYS_ON_BY_MODULE[moduleKey];
  if (!list?.length) return false;
  return roles.some((r) => list.includes(r));
}
